<template>
  <div class="production-time-container">
    <div
      :class="['production-time__item']"
      v-for="(item, index) in allProductionTimes"
      :key="index"
      @click="onClick(item)">
      <button
        type="button"
        :class="[
          'btn-select',
          'trans',
          currentProductionTime === item ? 'is-active' : '',
          item.enabled ? '' : 'is-disabled'
        ]">
        {{ item.needCalcDelivery ?item.title :'To be determined' }}
      </button>
      <label class="price-difference" v-if="item.priceDifference > 0"
        >+{{ formatCurrency(item.priceDifference) }}</label
      >
    </div>
  </div>
</template>
<script lang="ts"></script>
<script setup lang="ts">
import { computed } from 'vue'
import { type ProductionTimeItem } from '../composables'
import { showPopupProductionTimeGroup } from '../components/production-time-group'
import { useProductionTime } from '../store/modules/productionTime'
import { formatCurrency } from '@anypromo/shared/utils/helper'

const productionTimeState = useProductionTime()

const emit = defineEmits(['change'])
const allProductionTimes = computed(
  () => productionTimeState.getAllProductionTime
)
const currentProductionTime = computed(
  () => productionTimeState.getCurrentProductionTime
)

const onClick = (item: ProductionTimeItem) => {
  if (item.enabled === false) {
    showPopupProductionTimeGroup({
      isBlank: false
    })
    return
  }
  if (item.productionTime === currentProductionTime.value?.productionTime){
    return
  }

  productionTimeState.setCurrentProductionTime(item)
  emit('change', item)
}
</script>
<style lang="less">
.production-time {
  &-container {
    margin-top: 15px;
    padding-left: 28px;
    min-height: 70px;
    display: flex;
  }
  &__item {
    display: flex;
    margin-left: 5px;
    flex-direction: column;
    &:first-child {
      margin-left: 0;
    }
    &.is-active {
    }
    .price-difference {
      font-weight: 500;
      text-align: center;
      font-size: 13px;
    }
  }
}
</style>
